import React from "react";
import styles from "@/styles/Ui.module.scss"
import clsx from 'clsx'
import CloseIcon from "@/svg/CloseIcon.tsx";

interface Props {
    onClick():void
    className?: string
    light?:boolean
    dark?:boolean
}

const CloseBtn:React.FC<Props> = ({onClick, className, light, dark}) => {
    return (
        <button
            aria-label={"close"}
            onClick={(e) => {
                e.stopPropagation()
                onClick()
            }}
            className={clsx(
                styles.closeBtn,
                light && styles.light,
                dark && styles.dark,
                className,
            )}
        >
            <CloseIcon />
        </button>
    )
}

export default CloseBtn